import useMediaQuery from '@/hooks/use-media-query'
import { useTranslation } from 'react-i18next'
import { breakpoints } from '@/styles'
import { StyledTableCell } from '@/components/listings-table'
import { Box, TooltipRenderer, Text } from '@machobear/design-system'
import HeartSelected from '../images/heart-active.svg'
import HeartUnselected from '../images/heart.svg'
import { HeartImage } from '../images/heart-image'

type FavouriteProps = {
  trustScoreInfo: any
  favouriteTrustScore: () => void
}

export const getTrustScoreFavouriteHeader = currentFavourite =>
  currentFavourite ? HeartSelected : HeartUnselected

const getTrustScoreFavourite = (trustScoreInfo: Omit<FavouriteProps, 'favouriteTrustScore'>) => {
  return trustScoreInfo.favourite === true || trustScoreInfo.favourite === '1'
    ? HeartSelected
    : HeartUnselected
}

export const Favourite = ({ trustScoreInfo, favouriteTrustScore }: FavouriteProps) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const { t } = useTranslation()

  const getFavouriteMethod = async () => {
    try {
      await favouriteTrustScore?.mutateAsync({ id: trustScoreInfo.id })
    } catch (error) {
      console.error('Error favouriting trust score data', error)
    }
  }

  return (
    <StyledTableCell
      colSpan="1"
      width="10%"
      paddingTop={isMobile ? '6px' : '0px'}
      verticalAlign={isMobile ? 'top' : 'middle'}
      onClick={e => {
        e.stopPropagation()
        getFavouriteMethod()
      }}
    >
      {trustScoreInfo.favourite === '0' ? (
        <TooltipRenderer
          id={`tooltip-tenant-${trustScoreInfo.id}`}
          tooltip={
            <Box paddingY="xxxsmall" justifyContent="center">
              <Text size="small">
                {t('l.application.table.heart_unselected.add_to_favourites', 'Add to favourites')}
              </Text>
            </Box>
          }
        >
          {({ triggerProps }) => (
            <Box
              {...triggerProps}
              display="flex"
              alignItems="center"
              justifyContent="center"
              paddingX={{ mobile: 'gutter', tablet: 'small' }}
            >
              <HeartImage src={getTrustScoreFavourite(trustScoreInfo)} />
            </Box>
          )}
        </TooltipRenderer>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingX={{ mobile: 'gutter', tablet: 'small' }}
        >
          <HeartImage src={getTrustScoreFavourite(trustScoreInfo)} />
        </Box>
      )}
    </StyledTableCell>
  )
}
